import * as React from 'react'
import * as PrismaManufacturerStatus from '../Entities/PrismaManufacturerStatus'
import Chip from 'material-ui/Chip'
import Avatar from 'material-ui/Avatar'
import Cancel from 'mdi-material-ui/Cancel'
import Coin from 'mdi-material-ui/Coin'
import DotsHorizontal from 'mdi-material-ui/DotsHorizontal'
import Check from 'mdi-material-ui/Check'
import Help from 'mdi-material-ui/Help'
import injectSheet from 'react-jss'
import {WithClasses} from './Helper'
import {ChipWrapper} from './ChipWrapper'
import { Cart } from 'mdi-material-ui'

const styles = {
}

interface Properties {
    readonly status: PrismaManufacturerStatus.M
}

export const PrismaManufacturerStatusView =
    injectSheet<Properties>(styles)(
        ({classes, status}: WithClasses<Properties>) => (
            <ChipWrapper>
                {(() => {
                    const label = PrismaManufacturerStatus.label(status)
                    switch (status) {
                        case 'Canceled':
                            return (
                                <Chip
                                    labelColor="#fff"
                                    backgroundColor="#DD2C00"
                                >
                                    <Avatar backgroundColor="#831800">
                                        <Cancel color="#fff"/>
                                    </Avatar>
                                    {label}
                                </Chip>
                            )
                        case 'PriceSubmissionPossible':
                            return (
                                <Chip
                                    labelColor="#000"
                                    backgroundColor="#00BCD4"
                                >
                                    <Avatar backgroundColor="#00838F">
                                        <Coin color="#fff"/>
                                    </Avatar>
                                    {label}
                                </Chip>
                            )
                        case 'WaitingForAssignment':
                            return (
                                <Chip
                                    labelColor="#000"
                                    backgroundColor="#D4E157"
                                >
                                    <Avatar backgroundColor="#9E9D24">
                                        <DotsHorizontal color="#fff"/>
                                    </Avatar>
                                    {label}
                                </Chip>
                            )
                        case 'Assigned':
                            return (
                                <Chip
                                    labelColor="#fff"
                                    backgroundColor="#43A047"
                                >
                                    <Avatar backgroundColor="#1B5E20">
                                        <Check color="#fff"/>
                                    </Avatar>
                                    {label}
                                </Chip>
                            )
                        case 'NotAssigned':
                            return (
                                <Chip
                                    labelColor="#000"
                                    backgroundColor="#FFA726"
                                >
                                    <Avatar
                                        backgroundColor="#E65100"
                                        color="#fff"
                                    >
                                        –
                                    </Avatar>
                                    {label}
                                </Chip>
                            )
                        case 'Inactive':
                            return (
                                <Chip>
                                    <Avatar><Help/></Avatar>
                                    {label}
                                </Chip>
                            )
                        case 'Declined':
                            return (
                                <Chip
                                    labelColor="#000"
                                    backgroundColor="#ff2626"
                                >
                                    <Avatar
                                        backgroundColor="#b21c1c"
                                        color="#fff"
                                    >
                                        X
                                    </Avatar>
                                    {label}
                                </Chip>
                            )
                        case 'Ordered':
                            return (
                                <Chip
                                    labelColor="#fff"
                                    backgroundColor="#415bf2"
                                >
                                    <Avatar backgroundColor="#1b39e5">
                                        <Cart color="#fff"/>
                                    </Avatar>
                                    {label}
                                </Chip>
                            )
                    }
                })()}
            </ChipWrapper>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/PrismaManufacturerStatusView.tsx